<template>
    <div>
        <div v-if="view" class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex tickets-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="view = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between tickets-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Ticket Detail</p>
                            <a :href="`/cottonseed-tickets/${ticket.id}/download`" target="_blank" class="flex items-center text-blue-600 cursor-pointer">
                                <svg class="w-6 h-6 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path></svg>
                                <span class="font-semibold">Print / Export</span>
                            </a>
                            <svg @click="view = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-5 pb-4 sm:p-6 lg:grid lg:grid-cols-12 lg:gap-x-8">
                            <section class="lg:col-span-4">
                                <div class="px-6 py-4 bg-blue-50 mb-6">
                                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ ticket.load_ticket_number  }}</div>
                                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Ticket Number</div>
                                </div>
                                <div class="px-6 py-4 bg-blue-50 mb-6">
                                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ ticket.truck_name }}</div>
                                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Trucker</div>
                                </div>
                                <div class="px-6 py-4 bg-blue-50 mb-6">
                                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ $page.props.auth.user.name }}</div>
                                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Gin</div>
                                </div>
                            </section>
                            <section class="lg:col-span-8">
                                <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 sm:px-6">
                                    <h2 class="text-lg leading-6 font-medium text-gray-900">Details</h2>
                                </div>
                                <div class="mt-6 flex flex-col">
                                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                            <div class="overflow-hidden border-t border-gray-200">
                                                <table class="min-w-full divide-y divide-gray-200">
                                                    <tbody class="bg-white divide-y divide-gray-200">
                                                        <tr>
                                                            <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                               Operator In
                                                            </td>
                                                            <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                                {{ ticket.operator_in }} @ {{ ticket.time_in }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Operator Out
                                                            </td>
                                                            <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                                {{ ticket.operator_out }} @ {{ ticket.time_out }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Gross Weight
                                                            </td>
                                                            <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                                {{ ticket.gross_weight | numberInThousands }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Tare Weight
                                                            </td>
                                                            <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                                {{ ticket.tare_weight | numberInThousands }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Net Weight
                                                            </td>
                                                            <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                                {{ ticket.net_weight | numberInThousands }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            view: false,
            ticket: {}
        }
    },
    mounted() {
        this.$eventBus.$on('show-cottonseed-ticket-details', (ticket) => {
            this.view = true
            this.ticket = ticket
        })
    }
}
</script>
